// extracted by mini-css-extract-plugin
export default {"auth-provider-container":"AuthProvider_auth-provider-container__OOmvJ"};